import { render } from "./tot-input-modal.vue?vue&type=template&id=5fd41a28"
import script from "./tot-input-modal.vue?vue&type=script&lang=js"
export * from "./tot-input-modal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__